import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import { getQueryParamsOrderForm } from "../services/order-add-edit-service";
import FloorPlanModal from "./modals/FloorPlanModal";
import useTableManagementStorage from "../stores/useTableManamentStore";
import { getOrCreateSessionId } from "../utils/Common";
import { replaceSelectedTablesInStore, setFloorPlanModalActionMode } from "../utils/store-mutator.table-management";

/**
 * context can be PAYMENT, ORDER
 */
function OrderFormHeaderComponent({ context, title }) {
  const { isTableManagement, isTakeout } = getQueryParamsOrderForm();
  const navigate = useNavigate();
  const { idWiseSelectedTablesOrg, getIdWiseSelectedTables, getIdWiseSelectedTablesOrg } = useTableManagementStorage();
  const [isOpenFloorPlanModal, setIsOpenFloorPlanModal] = useState(false);
  const [tableNumbers, setTableNumbers] = useState("");

  const sessionId = getOrCreateSessionId();

  function onHandleListRoute() {
    navigate("/order");
  }

  function onHandleModalOk() {
    console.log("******onHandleModalOk****called***");
    const tmpArr = getIdWiseSelectedTables(sessionId);

    replaceSelectedTablesInStore(tmpArr, true);
    setIsOpenFloorPlanModal(false);
  }

  function onHandleModalCancel() {
    console.log("******onHandleModalCancel****called***");

    const tmpArr = getIdWiseSelectedTablesOrg(sessionId);
    replaceSelectedTablesInStore(tmpArr);
    setIsOpenFloorPlanModal(false);
  }

  const onClickAddMoreButton = () => {
    setFloorPlanModalActionMode("ADD_MORE_TABLE");
    setIsOpenFloorPlanModal(true);
  };

  useEffect(() => {
    const tmpArr = getIdWiseSelectedTablesOrg(sessionId);
    setTableNumbers(tmpArr.map((item) => item.tableName).join(", "));
  }, [idWiseSelectedTablesOrg[sessionId]]);

  return (
    <>
      <div className="flex flex-row mb-[16px] font-uregular py-[16px] w-full items-center justify-between">
        <div className="text-xl font-p_bold">{title}</div>
        {!isTableManagement && (
          <div className="flex flex-row">
            <div
              className="px-[16px] py-[8px] rounded bg-yellow text-md font-ubold cursor-pointer"
              onClick={() => onHandleListRoute()}
            >
              List
            </div>
          </div>
        )}
        {isTableManagement && (
          <div className="flex flex-row gap-4 items-center pr-6">
            <div className="rounded text-md font-ubold">
              {isTakeout ? <span>Takeout</span> : <span>Table No - {tableNumbers}</span>}
            </div>
            {!isTakeout && context === "ORDER" && (
              <div className="pl-[16px] rounded text-md font-ubold cursor-pointer">
                <button className="mt-1" onClick={onClickAddMoreButton}>
                  <Image src="/images/icons/add-green.svg" preview={false} />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <FloorPlanModal
        context={"ADD_MORE_TABLE"}
        openModal={isOpenFloorPlanModal}
        onHandleCancel={onHandleModalCancel}
        addMoreTableHandler={onHandleModalOk}
      />
    </>
  );
}

export default OrderFormHeaderComponent;
